import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import TitlePrint from 'App/Shell/TitlePrint'

const PointsPurchaseFormHeader = () => (
  <div className='bg-comprarpontos bg-paguecontas radius-top row align-items-center px-1'>
    <div className='col-12 px-3'>
      <h2 className='color-ui-white txt-title-2 txt-circular-book'>
        Comprar pontos
      </h2>
    </div>
  </div>
)

const PointsPurchaseFormWrapper = ({ children, packageSize }) => (
  <Fragment>
    <TitlePrint page={'Comprar pontos'} />
    <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2'>
      <div className='row mx-0 pt-0'>
        <div className='col-12 radius border border-color-ui-3'>
          <div className='row'>
            <div className='col-12'>
              <PointsPurchaseFormHeader />
              <div className='row radius-bottom bg-white px-1'>
                <div className='col-12 px-2 pt-2'>
                  <p className='txt-body-sm'>
                    Selecione o valor em pontos que deseja comprar e pague o valor
                    em R$ com seu cartão de crédito.
                  </p>
                </div>
                <div className='col-12 px-2 pb-3'>
                  <div className='payment-item border-color-ui-3 row mx-0'>
                    <div className='method-creditcard col-12 mt-2 border-dashed-top border-color-ui-3 py-2'>
                      <div className='payment-step h-auto row'>{children}</div>
                    </div>
                    <div className='col-12 border-dashed-top border-color-ui-3 pt-2'>
                      <p className='txt-body-sm txt-bold pb-1'>
                        Fique atento às condições da compra de pontos:
                      </p>
                      <p className='txt-body-sm'>
                        - Limites de compra: mínimo de {packageSize} pontos por compra e
                        máximo de 1.000.000 de pontos por ano civil;
                      </p>
                      <p className='txt-body-sm'>
                        - Os pontos comprados não possuem expiração;
                      </p>
                      <p className='txt-body-sm'>
                        - As condições da compra de pontos poderão ser alteradas,
                        suspensas ou cancelados sem aviso prévio;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

PointsPurchaseFormWrapper.propTypes = {
  children: PropTypes.node,
  packageSize: PropTypes.number
}

export default PointsPurchaseFormWrapper



// WEBPACK FOOTER //
// ./src/Checkout/PointsPurchase/PointsPurchaseFormWrapper.js